import { css } from "@emotion/react";
import type { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { Column, Row, Typography } from "@/frameworks/designStuff/components";

export const UserItem = styled(Row.div)`
	width: 100%;
	position: relative;
`;

export const Description = styled(Typography.p)`
	max-width: 204px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${({ theme }) => theme.colors.neutral_60_100};
`;

export const InfoArea = styled(Column)`
	padding-left: 12px;
	width: 100%;
	flex: 1;
`;

export const UserInfoWrapper = styled(Row)`
	flex: 1;
`;

export const textEllipsisStyle = (maxWidth: UnitString) => css`
	max-width: ${maxWidth};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const userItemButtonStyle = (
	theme: Theme,
	infoMaxWidth?: UnitString,
	hoverDescriptionMaxWidth?: UnitString,
	hoverNameMaxWidth?: UnitString,
	activeBackground?: boolean,
	isUserButtonStyle?: boolean
) => css`
	padding: 6px 4px 6px 4px;
	width: 100%;
	height: auto;
	justify-content: left;
	color: ${theme.colors.primary_80_100};
	background: ${activeBackground ? theme.colors.accent_00_100 : theme.colors.transparent};
	border-radius: 8px;
	${isUserButtonStyle &&
	`
		cursor: pointer;
		:hover {
		color: ${theme.colors.primary_80_100};
		background: ${theme.colors.secondary_80_8};

		.user-description {
			max-width: ${hoverDescriptionMaxWidth ? hoverDescriptionMaxWidth : infoMaxWidth};
		}

		.user-name {
			max-width: ${hoverDescriptionMaxWidth ? hoverNameMaxWidth : infoMaxWidth};
		}

		.hidden {
			transition: opacity 0.25s ease-in-out;

			opacity: 1;
		}

		.call-time {
			display: none;
		}
	}`}
`;

export const fullWidthStyle = css`
	width: 100%;
`;

export const IconWrapper = styled(Row)<{ type?: "group" | "space" | "channel" }>`
	width: 20px;
	height: 20px;
	background: ${({ theme, type }) => {
		switch (type) {
			case "group":
				return "linear-gradient(225deg, #E3FFFC 0%, #CBD7FF 50.5%, #F097FF 100%)";
			case "space":
				return theme.colors.accent_20_100;
			case "channel":
				return theme.colors.accent_10_100;
			default:
				return theme.colors.accent_20_100;
		}
	}};
	border-radius: 50%;
`;

export const BlockIconWrapper = styled(Row)`
	width: 20px;
	height: 20px;
	background: ${({ theme }) => theme.colors.error_20_100};
	border-radius: 50%;
`;
